import React from 'react';
import { Box, Typography } from '@mui/material';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';

// Shared by every public, no-login page (report links, script review links) —
// badgeLabel says what the visitor can do there.
const PublicReportHeader = ({ campaignName, badgeLabel = 'View Only' }) => (
    <Box sx={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200,
        height: 56,
        background: 'rgba(255,255,255,0.88)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderBottom: '1px solid rgba(0,0,0,0.07)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        px: { xs: 2, sm: 3 },
    }}>
        {/* Brand mark */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{
                width: 28, height: 28, borderRadius: '8px',
                background: 'linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(255,82,0,0.35)',
            }}>
                <InsightsOutlinedIcon sx={{ fontSize: 16, color: '#fff' }} />
            </Box>
            <Typography sx={{ fontSize: 15, fontWeight: 800, color: '#0B0B0B', letterSpacing: '-0.02em' }}>
                Meesha
            </Typography>
        </Box>

        {/* Campaign name */}
        {campaignName && (
            <Typography sx={{
                fontSize: 13, fontWeight: 600, color: '#52514E',
                maxWidth: { xs: 180, sm: 400 },
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
                {campaignName}
            </Typography>
        )}

        {/* Read-only badge */}
        <Box sx={{
            px: 1.5, py: 0.5, borderRadius: '20px',
            background: 'linear-gradient(135deg, rgba(255,82,0,0.1) 0%, rgba(255,140,0,0.06) 100%)',
            border: '1px solid rgba(255,82,0,0.2)',
        }}>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: '#FF5200', letterSpacing: '0.04em' }}>
                {badgeLabel}
            </Typography>
        </Box>
    </Box>
);

export default PublicReportHeader;
